export default (el) => el.parentNode.removeChild(el);
